import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const DISASTER_RECOVERY_DOCS_URL =
  'https://docs.mls.onchainden.com/enterprise-security/disaster-recovery#disaster-recovery';

interface DisasterRecoveryLearnMoreLinkProps {
  label?: string;
  className?: string;
}

/**
 * Shared light-mode docs link used across DR setup and settings surfaces.
 */
export function DisasterRecoveryLearnMoreLink({
  label = 'Learn more about the timelock',
  className,
}: DisasterRecoveryLearnMoreLinkProps) {
  return (
    <Button
      asChild
      variant="ghost"
      size="sm"
      className={cn(
        // size="sm" adds has-[>svg]:px-2.5 (10px); p-0 alone does not override that via tailwind-merge
        'h-auto w-fit gap-1 self-start justify-start px-0 py-0 has-[>svg]:px-0 text-xs font-medium text-zinc-500 underline underline-offset-2 hover:bg-transparent hover:text-zinc-700',
        className
      )}
    >
      <a
        href={DISASTER_RECOVERY_DOCS_URL}
        target="_blank"
        rel="noreferrer noopener"
      >
        {label}
        <ExternalLink className="h-3.5 w-3.5" />
      </a>
    </Button>
  );
}
